import { SyntheticEvent, useEffect, useState } from 'react';
import { TRANSITION_TIME } from './atoms';

export type TransitionState = 'mounting' | 'entering' | 'exiting' | 'exited';

const EXIT_TIMEOUT_MS = TRANSITION_TIME + 50;

const getCurrentState = (
  state: TransitionState,
  isOpen: boolean
): TransitionState => {
  if (isOpen && state === 'exited') return 'mounting';
  if (isOpen && state === 'mounting') return 'entering';
  if (!isOpen && state === 'entering') return 'exiting';
  if (!isOpen && state === 'exiting') return 'exited';
  if (!isOpen && state === 'mounting') return 'exited';
  return state;
};

export const useTransitionState = (
  isOpen: boolean
): [TransitionState, (event?: SyntheticEvent) => void] => {
  const [state, setState] = useState<TransitionState>('exited');
  const currentState = getCurrentState(state, isOpen);

  useEffect(() => {
    if (currentState !== 'exiting') return;
    const timer = setTimeout(() => setState('exited'), EXIT_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [currentState]);

  const updateState = (event?: SyntheticEvent) => {
    if (event && event.target !== event.currentTarget) return;
    setState(getCurrentState(currentState, isOpen));
  };

  return [currentState, updateState];
};
